export function inputZip() {
    const zipField = document.querySelector<HTMLFormElement>("#zip");
    if (zipField) {
        zipField.addEventListener("change", (event) => {
            event.preventDefault();
            const target = event.target as HTMLFormElement;
            let zip = target.value;
            zip = zip.replace(/\D/g, "");
            const api_url = `/order/api_getort/${zip}/`;
            const myHeaders = new Headers({
                "Content-Type": "text/html",
                "X-Requested-With": "XMLHttpRequest",
            });
            const settings: RequestInit = {
                method: "GET",
                headers: myHeaders,
                mode: "cors",
                cache: "default",
            };

            if (zip != "") {
                fetch(api_url, settings)
                    .then(function (response) {
                        return response.text();
                    })
                    .then(function (data) {
                        if (data != null) {
                            const city =
                                document.querySelector<HTMLFormElement>(
                                    "#city",
                                );
                            if (city) {
                                city.value = data;
                            }
                        }
                    });
            }
        });
    }
}
